<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <media-reference
            :language="form.language"
            v-model="form.media"
            class="mt-3"
            label="* Footer Site Logo"
            :media-types="['Logo']"
            name="media_id"
            :error="errors.media_id ? errors.media_id[0] : null"
        />

        <input-text
            name="url"
            class="mt-3"
            label="URL"
            v-model="form.url"
            :error="errors.url ? errors.url[0] : null"
            :maxlength=200
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "FooterLogoForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                media_id: this.getFormData("media_id"),
                media: this.getFormData("media"),
                url: this.getFormData("url"),
            },
        };
    },
    watch:{
        "form.media": function(){
            this.form.media_id = this.form.media && this.form.media.id ? this.form.media.id : null;
        }
    }
};
</script>
